import React from 'react';
import cx from 'classnames';
import { SLDSColorPicker } from '@salesforce/design-system-react';

function ColorPicker({
  className,
  ...props
}) {
  return /*#__PURE__*/React.createElement(SLDSColorPicker, Object.assign({}, props, {
    className: cx(className, "tds-color-picker")
  }));
}
ColorPicker.displayName = "ColorPicker";
ColorPicker.propTypes = SLDSColorPicker.propTypes;
ColorPicker.defaultProps = SLDSColorPicker.defaultProps;

export { ColorPicker as default };
